// src/components/pages/auth/SignupForm.js
// for login with email and password

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../form/input";
import PasswordInput from "../../form/passwordInput";
import Btn from "../../form/btn";
import { Link } from "react-router-dom";

const API_URL = "https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1";

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function validatePassword(password) {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
    password
  );
}

export default function SignInForm() {
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "yavcode1@gmail.com",
    password: "Password@123",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // on Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent multiple submissions
    if (isLoading) return;
    
    const errors = {};
    if (!validateEmail(formData.email)) {
      errors.email = "Invalid email address";
    }

    if (!validatePassword(formData.password)) {
      errors.password = "Invalid password";
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    // send the data to the server
    const data = {
      email: formData.email,
      password: formData.password,
    };
    
    // Reset errors and set loading state
    setErrors({});
    setIsLoading(true);

    // send the data to the server
    fetch(`${API_URL}/auth/signin`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        const contentType = res.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          return res.json();
        } else {
          throw new Error("Server returned non-JSON response");
        }
      })
      .then((data) => {
        console.log("Response data:", data); // Log the response data for debugging

        if (data.errors) {
          // Initialize with any existing errors
          setErrors((prev) => {
            const newErrors = { ...prev };

            // Check for specific error messages
            if (typeof data.errors === "string") {
              if (data.errors === "User not found. Please sign up.") {
                newErrors.general = "User not found. Please sign up.";
              } else {
                // For any other string error message
                newErrors.general = data.errors;
              }
            } else if (Array.isArray(data.errors)) {
              // Check each possible error condition independently
              if (data.errors.includes("Phone number already in use")) {
                newErrors.phone = "Phone number already in use";
              }
              if (data.errors.includes("Username already in use")) {
                newErrors.userName = "Username already in use";
              }
              if (data.errors.includes("Email already in use")) {
                newErrors.email = "Email already in use";
              }
            }

            return newErrors;
          });
        } else {
          // Success case - continue with your existing code
          // Clear form on success
          setFormData({
            email: "",
            password: "",
          });
          setIsChecked(false);

          // Store token if provided
          if (data.token) {
            localStorage.setItem("token", data.token);
          }

          // Redirect on success to the OTP page with the email in body
          navigate("/signin/otp", {
            state: {
              password: formData.password,
              email: formData.email,
            },
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error during signin:", error);
        setErrors({
          general:
            error.message ||
            "Failed to connect to the server. Please try again later.",
        });
        setIsLoading(false);
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      {errors && errors.general && (
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
          role="alert"
        >
          <span className="block sm:inline">{errors.general}</span>
        </div>
      )}

      <Input
        type="email"
        placeholder="Ex : gamie@gmail.com"
        label="Email"
        id="email"
        value={formData.email}
        onChange={(e) => {
          setFormData((prev) => ({
            ...prev,
            email: e.target.value,
          }));
        }}
        required
        error={errors.email}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          className="w-5 h-5"
        >
          <path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z" />
        </svg>
      </Input>
      <PasswordInput
        placeholder="Ex : **********"
        label="Password"
        id="password"
        value={formData.password}
        onChange={(e) => {
          setFormData((prev) => ({
            ...prev,
            password: e.target.value,
          }));
        }}
        required
        error={errors.password}
      />
      <div className="flex items-center justify-end gap-4">
        <Link
          to="/forgot-password"
          className="text-[#F15213] hover:text-[#F15213]/80 text-sm"
        >
          Forgot your password?
        </Link>
      </div>
      <div className="flex items-center justify-start  cursor-pointer">
        <input
          type="checkbox"
          id="checkbox"
          className="mr-2 w-5 h-5 p-2 checked:bg-[#F15213]"
          onChange={(e) => {
            setIsChecked(e.target.checked);
          }}
          checked={isChecked}
        />
        <label htmlFor="checkbox" className="cursor-pointer">
          Remember me
        </label>
      </div>
      <Btn type="submit" disabled={isLoading}>
        {isLoading ? (
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
            Signing In...
          </div>
        ) : (
          "Sign In"
        )}
      </Btn>
    </form>
  );
}
